import { render, staticRenderFns } from "./MspAllenamentoPreview.vue?vue&type=template&id=173658a4"
import script from "./MspAllenamentoPreview.vue?vue&type=script&lang=js"
export * from "./MspAllenamentoPreview.vue?vue&type=script&lang=js"
import style0 from "./MspAllenamentoPreview.vue?vue&type=style&index=0&id=173658a4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports